var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
var Breadcrumbs = function (_a) {
    var breadcrumbsContent = _a.breadcrumbsContent;
    if (!breadcrumbsContent || breadcrumbsContent.items.length === 0) {
        return _jsx(_Fragment, {});
    }
    var items = breadcrumbsContent.items;
    return (_jsxs("div", { children: [_jsx("nav", __assign({ className: "sm:hidden", "aria-label": breadcrumbsContent.backText }, { children: _jsxs("a", __assign({ href: items.length >= 2 ? items[items.length - 2].href : items[0].href, className: "flex items-center text-sm font-medium text-gray-500 hover:text-gray-700" }, { children: [items.length >= 2
                            ?
                                _jsx(ChevronLeftIcon, { className: "-ml-1 mr-1 h-5 w-5 flex-shrink-0 text-gray-400", "aria-hidden": "true" })
                            : _jsx(_Fragment, {}), items.length === 1
                            ? items[0].name
                            : breadcrumbsContent.backText] })) })), _jsx("nav", __assign({ className: "hidden sm:flex", "aria-label": "Breadcrumb" }, { children: _jsx("ol", __assign({ role: "list", className: "flex items-center space-x-4" }, { children: items.map(function (item, index) {
                        var isFirst = index === 0;
                        return (_jsx("li", { children: _jsxs("div", __assign({ className: "flex items-center" }, { children: [!isFirst &&
                                        _jsx(ChevronRightIcon, { className: "h-5 w-5 flex-shrink-0 text-gray-400", "aria-hidden": "true" }), _jsx("a", __assign({ href: item.href, className: "text-sm font-medium text-gray-500 hover:text-gray-700 ".concat(!isFirst && "ml-4") }, { children: item.name }))] })) }, index));
                    }) })) }))] }));
};
export default Breadcrumbs;
